import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error("Password must be at least 8 characters."); return; }
    if (pw !== confirm) { toast.error("Passwords don't match."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated — you can log in now.");
      nav("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't reset password.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background grain px-4">
      <div className="w-full max-w-sm border-2 border-foreground bg-card p-8">
        <h1 className="font-display text-4xl uppercase leading-none mb-2 flex items-center gap-2">
          <KeyRound className="text-primary" size={28} /> New<br />password
        </h1>
        {!token ? (
          <div className="mt-4 text-sm text-muted-foreground" data-testid="reset-no-token">
            This link is missing its token. Please request a new reset link from{" "}
            <Link to="/forgot-password" className="text-primary underline">Forgot password</Link>.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-4 space-y-3">
            <p className="text-sm text-muted-foreground">Choose a new password (min 8 characters).</p>
            <Input type="password" autoComplete="new-password" required value={pw} onChange={(e) => setPw(e.target.value)}
              placeholder="New password" data-testid="reset-new" className="rounded-none" />
            <Input type="password" autoComplete="new-password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
              placeholder="Confirm new password" data-testid="reset-confirm" className="rounded-none" />
            <Button type="submit" disabled={loading} data-testid="reset-submit"
              className="w-full rounded-none bg-primary text-primary-foreground uppercase font-bold">
              {loading ? "Saving…" : "Set new password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
